import { forwardRef } from 'react';
import PropTypes from 'prop-types';

// Utils
import { cn } from 'utils';

// Component
import InputWrapper from '../InputWrapper/InputWrapper';

// Styles
import styles from './TextField.module.css';

const TextField = forwardRef(({
  name,
  label,
  maxWidth,
  error,
  type,
  multiline,
  rows,
  className,
  inputClassName,
  placeholder,
  required,
  onBlur,
  onBlurDelay,
  disabled,
  color,
  ...props
}, ref) => {
  const Tag = multiline ? 'textarea' : 'input';

  const handleBlur = (e) => {
    if (onBlurDelay) {
      setTimeout(() => { onBlur(e); }, onBlurDelay);
    } else {
      onBlur(e);
    }
  };

  return (
    <InputWrapper
      label={label}
      className={cn([className])}
      inputClassName={inputClassName}
      required={required}
      maxWidth={maxWidth}
      error={error}
      disabled={disabled}
      color={color}
    >
      <Tag
        {...props}
        type={type}
        id={name}
        name={name}
        rows={multiline ? rows : undefined}
        ref={ref}
        placeholder={placeholder || label}
        className={cn([styles.input, styles[color]])}
        onBlur={handleBlur}
        disabled={disabled}
        color={color}
      />
    </InputWrapper>
  );
});

TextField.displayName = 'TextField';

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  onBlur: PropTypes.func,
  onBlurDelay: PropTypes.number,
  multiline: PropTypes.bool,
  maxWidth: PropTypes.number,
  label: PropTypes.string,
  type: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf(['black', 'white', 'dark', 'light', '']),
};

TextField.defaultProps = {
  error: '',
  onBlur: () => {},
  onBlurDelay: null,
  multiline: false,
  maxWidth: null,
  label: '',
  type: 'text',
  rows: 4,
  className: null,
  inputClassName: null,
  placeholder: '',
  required: false,
  disabled: false,
  color: 'white',
};

export default TextField;
